import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Evaluation } from '@/apis/evaluations/types/evaluationsApi';
import {
  evaluationFromApiAdapter,
  millwrightEvaluationsFromApiAdapter,
} from '@/apis/evaluations/adapters/evaluationFromApiAdapter';
import { PaginatedResponse } from '@/types';
import { prepareHeadersWithAuthorization as prepareHeaders } from '@/apis/headers';

const BASE_URL = import.meta.env.VITE_APP_API_URL;

export interface GetMillwrightEvaluationsParams {
  empId: number;
  outageId?: number;
  days?: number;
  limit?: number;
  offset?: number;
}

export interface GetLatestEvaluationParams {
  empId: number;
  outageId?: number;
}

export const evaluationsApi = createApi({
  reducerPath: 'evaluationsApi',
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL, prepareHeaders }),
  endpoints: (builder) => ({
    getMillwrightEvaluations: builder.query<
      PaginatedResponse<Evaluation | null>,
      GetMillwrightEvaluationsParams
    >({
      query: ({ empId, outageId, days, limit, offset }) => ({
        url: `/employees/${empId}/evaluations`,
        params: {
          ...(outageId && { outage_id: outageId }),
          ...(days && { days }),
          ...(limit && { limit }),
          ...(offset && { offset }),
        },
      }),
      transformResponse: millwrightEvaluationsFromApiAdapter,
    }),
    getLatestEvaluation: builder.query<
      Evaluation | null,
      GetLatestEvaluationParams
    >({
      query: ({ empId, outageId }) => ({
        url: `/employees/${empId}/evaluations/latest`,
        params: {
          ...(outageId && { outage_id: outageId }),
        },
      }),
      transformResponse: evaluationFromApiAdapter,
    }),
  }),
});

export const { useGetLatestEvaluationQuery, useGetMillwrightEvaluationsQuery } =
  evaluationsApi;
